import { render, staticRenderFns } from "./CategoriesFilter.vue?vue&type=template&id=24cf3884"
import script from "./CategoriesFilter.vue?vue&type=script&lang=js"
export * from "./CategoriesFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoriesFilter.vue?vue&type=style&index=0&id=24cf3884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports